<!-- ═══════════════ HEADER & STICKY NAVBAR ═══════════════ -->
<header class="sticky top-0 z-50 bg-black/85 backdrop-blur-xl border-b border-border-primary">
  <div class="max-w-[1320px] mx-auto px-6 lg:px-10 h-[76px] flex items-center justify-between">

    <!-- Logo and Brand -->
    <div class="flex items-center gap-3 shrink-0 cursor-pointer select-none" (click)="state.selectNav('home')">
      <div class="relative flex items-center justify-center shrink-0">
        <div class="absolute -inset-1 bg-gold/20 rounded-full blur-md animate-pulse"></div>
        <img src="/logo.png" alt="DEX" class="h-8 w-auto max-h-[30px] object-contain shrink-0 relative z-10 block" />
      </div>
      <span
        class="hidden sm:inline-flex items-center font-display font-black text-[26px] leading-none tracking-widest text-white uppercase translate-y-[0.5px]">DEX</span>
    </div>

    <!-- Main Navigation Menu Links -->
    <nav
      class="hidden min-[1300px]:flex items-center gap-8 text-[10.5px] font-semibold tracking-[0.18em] uppercase flex-1 justify-center">
      @for (link of state.navLinks; track link.id) {
      <a (click)="state.selectNav(link.id)"
        class="nav-link cursor-pointer transition-colors duration-200 pb-1 whitespace-nowrap"
        [class.nav-link-active]="state.activeNavLink() === link.id"
        [class.text-text-muted]="state.activeNavLink() !== link.id"
        [class.hover:text-white]="state.activeNavLink() !== link.id">{{ link.label }}</a>
      }
    </nav>

    <!-- Top Right Connect Wallet -->
    <div class="flex items-center gap-3 shrink-0">
      <!-- Blockchain Network Selector Dropdown -->
      <div class="relative">
        <button (click)="toggleNetworkMenu($event)"
          class="flex items-center gap-2.5 px-4 py-2 rounded-xl text-[12.5px] font-bold border border-border-primary bg-white/[0.02] text-white hover:border-gold/30 hover:bg-gold/[0.04] transition-all duration-200">

          @switch (state.selectedNetworkId()) {
          @case ('bnb') {
          <img src="/icons/bnb.png" class="w-4.5 h-4.5 object-contain rounded-full" alt="BNB" aria-hidden="true" />
          <span class="tracking-wide">BNB</span>
          }
          @case ('eth') {
          <img src="/icons/eth.png" class="w-4.5 h-4.5 object-contain rounded-full" alt="ETH" aria-hidden="true" />
          <span class="tracking-wide">ETH</span>
          }
          @case ('matic') {
          <img src="/icons/polygon.png" class="w-4.5 h-4.5 object-contain rounded-full" alt="MATIC"
            aria-hidden="true" />
          <span class="tracking-wide">MATIC</span>
          }
          }

          <svg class="w-3 h-3 text-text-dim ml-0.5 group-hover:rotate-180 transition-transform duration-200" fill="none"
            viewBox="0 0 24 24" stroke-width="2.8" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
          </svg>
        </button>

        <!-- Dropdown Menu -->
        <div
          class="absolute right-0 top-[100%] mt-2 w-48 bg-[#0c0c0c] border border-gold/20 rounded-xl shadow-[0_8px_30px_rgba(0,0,0,0.8)] transition-all duration-200 z-50"
          [class.opacity-100]="isNetworkMenuOpen()" [class.visible]="isNetworkMenuOpen()"
          [class.translate-y-0]="isNetworkMenuOpen()" [class.opacity-0]="!isNetworkMenuOpen()"
          [class.invisible]="!isNetworkMenuOpen()" [class.-translate-y-2]="!isNetworkMenuOpen()">
          <div class="p-2 flex flex-col gap-1">
            <button (click)="selectNetwork('bnb')"
              class="flex items-center gap-3 px-3 py-2 rounded-lg w-full text-left cursor-pointer transition-colors"
              [class.bg-gold]="state.selectedNetworkId() === 'bnb' ? false : false"
              [class.border-gold]="state.selectedNetworkId() === 'bnb' ? false : false"
              [class]="state.selectedNetworkId() === 'bnb' ? 'bg-gold/10 border border-gold/20' : 'hover:bg-white/[0.05] border border-transparent'">
              <img src="/icons/bnb.png" class="w-5 h-5 shrink-0 object-contain rounded-full" alt="BNB" />
              <span class="text-[12px] font-bold tracking-wide" [class.text-white]="state.selectedNetworkId() === 'bnb'"
                [class.text-[#999999]]="state.selectedNetworkId() !== 'bnb'">BNB Chain</span>
              @if (state.selectedNetworkId() === 'bnb') {
              <div class="ml-auto w-1.5 h-1.5 rounded-full bg-emerald-400"></div>
              }
            </button>
            <button (click)="selectNetwork('eth')"
              class="flex items-center gap-3 px-3 py-2 rounded-lg w-full text-left cursor-pointer transition-colors"
              [class]="state.selectedNetworkId() === 'eth' ? 'bg-gold/10 border border-gold/20' : 'hover:bg-white/[0.05] border border-transparent'">
              <img src="/icons/eth.png" class="w-5 h-5 shrink-0 object-contain rounded-full" alt="ETH" />
              <span class="text-[12px] font-bold tracking-wide" [class.text-white]="state.selectedNetworkId() === 'eth'"
                [class.text-[#999999]]="state.selectedNetworkId() !== 'eth'">Ethereum</span>
              @if (state.selectedNetworkId() === 'eth') {
              <div class="ml-auto w-1.5 h-1.5 rounded-full bg-emerald-400"></div>
              }
            </button>
            <button (click)="selectNetwork('matic')"
              class="flex items-center gap-3 px-3 py-2 rounded-lg w-full text-left cursor-pointer transition-colors"
              [class]="state.selectedNetworkId() === 'matic' ? 'bg-gold/10 border border-gold/20' : 'hover:bg-white/[0.05] border border-transparent'">
              <img src="/icons/polygon.png" class="w-5 h-5 shrink-0 object-contain rounded-full" alt="MATIC" />
              <span class="text-[12px] font-bold tracking-wide"
                [class.text-white]="state.selectedNetworkId() === 'matic'"
                [class.text-[#999999]]="state.selectedNetworkId() !== 'matic'">Polygon</span>
              @if (state.selectedNetworkId() === 'matic') {
              <div class="ml-auto w-1.5 h-1.5 rounded-full bg-emerald-400"></div>
              }
            </button>
          </div>
        </div>
      </div>

      <!-- Wallet Connected Trigger -->
      @if (state.isWalletConnected()) {
      <div class="flex items-center gap-2">
        <!-- Active Green Pulse -->
        <span class="w-2 h-2 rounded-full bg-emerald-400 animate-ping absolute"></span>
        <span class="w-2 h-2 rounded-full bg-emerald-500 relative"></span>
        <button (click)="state.disconnectWallet()"
          class="btn-gold px-5 py-2 rounded-xl text-[12.5px] font-extrabold tracking-wider uppercase border border-gold/20">
          {{ state.walletAddress() }}
        </button>
      </div>
      } @else {
      <button (click)="state.openConnectModal()"
        class="btn-gold px-6 py-2.5 rounded-xl text-[12.5px] font-extrabold tracking-widest uppercase shadow-[0_0_20px_rgba(245,183,59,0.22)]">
        Connect
      </button>
      }

      <!-- Mobile Menu Toggle -->
      <button (click)="toggleMobileMenu()" class="min-[1300px]:hidden text-white hover:text-gold transition-colors ml-1 p-1">
        <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          @if (isMobileMenuOpen()) {
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          } @else {
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
          }
        </svg>
      </button>
    </div>
  </div>

  <!-- Mobile Navigation Menu -->
  @if (isMobileMenuOpen()) {
  <div
    class="min-[1300px]:hidden absolute top-[76px] left-0 right-0 bg-black/95 backdrop-blur-xl border-b border-border-primary flex flex-col items-center py-6 gap-6 z-40 shadow-2xl animate-fade-in">
    @for (link of state.navLinks; track link.id) {
    <a (click)="selectNav(link.id)"
      class="nav-link cursor-pointer transition-colors duration-200 text-[13px] font-bold tracking-[0.18em] uppercase"
      [class.nav-link-active]="state.activeNavLink() === link.id"
      [class.text-text-muted]="state.activeNavLink() !== link.id"
      [class.text-white]="state.activeNavLink() === link.id">{{ link.label }}</a>
    }
  </div>
  }
</header>